import { frontendURL } from '../../../helper/URLHelper';

const FunnelsIndex = () => import('./pages/FunnelsIndex.vue');
const FunnelBoard = () => import('./pages/FunnelBoard.vue');

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/funnels'),
    component: FunnelsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'funnels_index',
        component: FunnelsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/funnels/:funnelId'),
    name: 'funnel_board',
    component: FunnelBoard,
    meta: commonMeta,
  },
];
